import type { SVGProps } from 'react';
const SvgParking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Parking_svg__a)">
      <path
        d="M6.5 8h1.625a1.625 1.625 0 0 0 0-3.25H6.5zm0 0v3M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Parking_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgParking;
